var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"min-height":"55vh"}},[_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('h2',[_vm._v(_vm._s(_vm.message)+" !")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }